import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Button, darken } from "@mui/material";
import { t } from "i18next";
import { iresoftColors } from "../../../theme/ireColors";

interface LoadMoreButtonProps {
  onClick: () => void;
}

const LoadMoreButton: React.FC<LoadMoreButtonProps> = ({ onClick }) => {
  return (
    <Button
      variant="contained"
      sx={{
        mt: 3,
        px: 3,
        py: 1,
        backgroundColor: iresoftColors.iresoftRed,
        color: iresoftColors.white,
        borderRadius: 4,
        "&:hover": {
          backgroundColor: darken(iresoftColors.iresoftRed, 0.15),
        },
      }}
      onClick={onClick}
      endIcon={<ExpandMoreIcon />}
    >
      {t("pages.historyReading.loadMore")}
    </Button>
  );
};

export default LoadMoreButton;
